import React from 'react';
import FormArquivoDocumento from '../ArquivoDocumento/CreateOrEdit';
export default function CreateOrEdit() { return <FormArquivoDocumento tipo />; }
